// Textos da área Nexus IA. Mesmo esquema do painel do SGP (ver ../sgp/i18n.js).

const PT = {
  NEUXS_NEXUS: {
    TITULO: 'Nexus IA',
    SEM_SGP:
      'Esta empresa ainda não tem recursos da Nexus IA ativados. As funções daqui (gateway, relatório de disparos e avisos de manutenção com o SGP; WhatsApp não oficial) aparecem quando forem ativadas: fale com o suporte da Nexus.',
    ABAS: {
      MANUTENCAO: 'Avisos de manutenção',
      GATEWAY: 'Gateway',
      DISPAROS: 'Relatório de disparos',
      USO: 'Uso do WhatsApp',
      TEIA: 'Nexus Neural',
    },
    // Rótulos curtos do menu lateral (o título da página continua o de ABAS).
    MENU: {
      DISPAROS: 'Disparos',
      MANUTENCAO: 'Manutenção',
      TEIA: 'Nexus Neural',
    },
    TEIA: {
      SUBTITULO: '{assistente} · a IA trabalhando agora',
      AO_VIVO: 'IA operando · {n} agentes',
      MODO_TV: 'Modo TV',
      SAIR_TV: 'Sair do modo TV',
      AGORA: 'clientes em atendimento pela IA agora',
      ATENDIDOS: 'atendidos hoje',
      RESOLVIDOS: 'resolvidos pela IA',
      EQUIPE: 'passados para a equipe',
      PASSAGENS: 'passagens entre IAs',
      RESPOSTA: 'resposta média',
      HORAS: 'horas da equipe economizadas',
      HORAS_DICA:
        'conta {min} min de um atendente por atendimento resolvido pela IA',
      AGENTES: 'Agentes',
      AGENTES_DICA: 'resolvidos / atendidos',
      FLUXO: 'Fluxo neural',
      FLUXO_VAZIO: 'Esperando a IA atender o próximo cliente…',
      PULSO: 'Pulso da IA',
      PULSO_DICA: 'passos por 4 segundos · últimos 4 min',
      ASSUNTOS: 'Assuntos de hoje',
      ASSUNTOS_DICA: 'etiquetas das conversas',
      SEM_ASSUNTOS: 'As etiquetas das conversas de hoje aparecem aqui.',
      DICA: 'clique num nó para ver o que ele faz · roda do mouse: zoom · arraste para mover',
      DICA_TOQUE:
        'toque num nó para ver o que ele faz · dois dedos: zoom e mover',
      ZOOM: {
        TITULO: 'Zoom',
        APROXIMA: 'Aproximar',
        AFASTA: 'Afastar',
        PADRAO:
          'Voltar ao tamanho e posição padrão (ou clique duas vezes na teia)',
      },
      MARCO: '{n} clientes resolvidos pela IA hoje',
      LEGENDA: {
        AGENTE: 'agente',
        FERRAMENTA: 'ferramenta',
        EQUIPE: 'equipe humana',
        CANAL: 'canal',
      },
      TIPOS: {
        nucleo: 'núcleo',
        agente: 'agente de IA',
        ferramenta: 'ferramenta',
        canal: 'canal',
        equipe: 'equipe',
      },
      CARTAO: {
        NUCLEO:
          'O núcleo que coordena os agentes: guarda o contexto de cada conversa e decide quem atende.',
        EQUIPE:
          'Quando o caso pede uma pessoa, a IA passa o cliente com o resumo da conversa.',
        CANAL: 'Por onde os clientes chegam à IA.',
        FERRAMENTA:
          'Uma consulta ou ação que os agentes fazem no sistema da empresa.',
        AGENTES_ATIVOS: 'Agentes ativos',
        MODELO: 'Modelo',
        ATENDIDOS: 'Atendidos hoje',
        RESOLVEU: 'Resolveu sozinha',
        PASSOU: 'Passou para a equipe',
        RESPOSTA: 'Tempo médio de resposta',
        CONSULTAS: 'Consultas hoje',
        CLIENTES: 'Clientes hoje',
        RECEBIDOS: 'Recebidos da IA hoje',
        USADA_POR: 'Usada por',
        FECHAR: 'Fechar',
      },
      TAGS: {
        chega: 'ENTRADA',
        passa: 'PASSAGEM',
        consulta: 'CONSULTA',
        responde: 'RESPOSTA',
        falha: 'FALHA',
        resolve: 'RESOLVIDO',
        equipe: 'EQUIPE',
      },
      PASSOS: {
        chega: 'cliente novo na fila da IA',
        passa: 'passa a conversa com o histórico',
        consulta: 'consulta feita',
        consulta_erro: 'a consulta falhou',
        responde: 'respondeu ao cliente',
        falha: 'o turno deu erro; a conversa segue com a IA',
        resolve: 'atendimento encerrado pela IA',
        cortesia: 'cliente agradeceu e o atendimento foi encerrado',
        equipe: 'resumo da conversa enviado',
        equipe_motivo: '{motivo} · resumo da conversa enviado',
      },
      EQUIPE_HUMANA: 'EQUIPE HUMANA',
      ERRO: 'Não consegui carregar a Nexus Neural.',
      SEM_AGENTES: 'Nenhum agente da IA ativo nesta empresa.',
    },
    USO: {
      EXPLICA:
        'Por onde saíram as mensagens de cada caixa e quanto a API oficial custa. Desde 01/10/2026 a Meta cobra as respostas enviadas pela API (depois de 1.000 grátis por número no mês); o que sai pelo aparelho e pelo celular não é cobrado.',
      MES: 'Mês',
      APARELHO: 'Pelo aparelho',
      APARELHO_DICA: 'grátis',
      RESPOSTA_API: 'Respostas pela API oficial',
      RESPOSTA_API_DICA: 'cobradas depois das 1.000 do mês',
      MODELOS: 'Modelos (templates)',
      MODELOS_DICA: 'cobrados à parte',
      CELULAR: 'Pelo celular',
      CELULAR_DICA: 'app Business e aparelhos, grátis',
      RECEBIDAS: '{n} recebidas',
      CUSTO: 'Custo estimado das respostas',
      ECONOMIA: 'Economia pelo aparelho',
      ESTIMATIVA:
        'Estimativa com US$ {preco} por resposta (preço de utilidade no Brasil). O desconto das 1.000 grátis só entra quando o período é um mês inteiro.',
      DIARIO: 'Por dia',
      SEM_CAIXAS: 'Nenhuma caixa de WhatsApp nesta empresa.',
      SEM_ENVIOS: 'Nenhuma mensagem enviada no período.',
      IA: 'IA',
      ATENDENTES: 'Atendentes',
      LADOS: '{aparelho} pelo aparelho · {oficial} pela oficial',
      PORQUE_OFICIAL: 'Por que foram pela oficial',
      FALHAS: '{n} com falha',
      COTA: 'Cota grátis deste mês: {usadas} de {total} usadas',
      QUEDAS: '{n} queda(s) do aparelho no período',
      HISTORICO: 'Histórico do aparelho',
      SEM_EVENTOS: 'Nenhuma mudança no período.',
      MOTIVOS: {
        sorteio: 'Sorteio da IA',
        automatico: 'Disparo automático',
        interativo: 'Botões e listas',
        sem_aparelho: 'Aparelho fora ou roteamento desligado',
        sem_telefone: 'Contato sem telefone',
        atendente: 'Atendentes pela oficial',
        falha_do_aparelho: 'Aparelho recusou',
      },
      ERRO: 'Não consegui carregar o uso do WhatsApp.',
    },
    WHATSAPP: {
      EXPLICA:
        'Aparelho conectado a cada caixa de WhatsApp. Caixa não oficial fala só pelo aparelho, sem custo por mensagem e sem janela de 24 horas. Caixa oficial com aparelho conectado fica híbrida.',
      NAO_CONFIGURADO:
        'O serviço de WhatsApp não oficial ainda não está configurado nesta instalação. Fale com o suporte da Nexus.',
      SEM_CAIXAS: 'Nenhuma caixa de WhatsApp ainda.',
      NOVA: 'Nova caixa não oficial',
      NOME: 'Nome da caixa',
      TELEFONE: 'Número do WhatsApp (com DDI e DDD)',
      CRIAR: 'Criar e conectar',
      CANCELAR: 'Cancelar',
      TIPOS: {
        nao_oficial: 'Não oficial',
        oficial: 'API oficial',
        hibrida: 'Híbrida',
        outro: 'Outro provedor',
      },
      ESTADOS: {
        sem_aparelho: 'Sem aparelho',
        aguardando: 'Iniciando',
        qr: 'Aguardando leitura do QR',
        qr_expirou: 'QR expirou',
        pareada: 'Pareado',
        conectada: 'Conectado',
        desconectada: 'Reconectando',
        deslogada: 'Desconectado pelo celular',
        banida: 'Bloqueado temporariamente',
        substituida: 'Aberto em outro lugar',
        numero_errado: 'Número diferente da caixa',
      },
      APARELHO: 'Aparelho {numero}',
      DESDE: 'desde {quando}',
      CONECTAR: 'Conectar aparelho',
      CONFIRMA_HIBRIDA:
        'Conectar o celular deste número como aparelho? A caixa continua na API oficial e passa a ser híbrida.',
      PAREAR: 'Parear',
      RECONECTAR: 'Reconectar',
      DESCONECTAR: 'Desconectar',
      CONFIRMA_DESCONECTAR:
        'O aparelho sai da lista de aparelhos conectados do celular. {efeito} Desconectar?',
      EFEITO_NAO_OFICIAL:
        'A caixa para de enviar e receber até conectar de novo.',
      EFEITO_HIBRIDA: 'A caixa volta a ser só da API oficial.',
      PAREAMENTO: 'Conectar {nome}',
      PASSOS:
        'No celular do número {telefone}: WhatsApp → Aparelhos conectados → Conectar um aparelho, e leia o código abaixo.',
      GERANDO_QR: 'Gerando o QR…',
      SEM_QR: 'O QR expirou. Clique em Reconectar para gerar outro.',
      QR_RENOVA:
        'O código se renova sozinho enquanto esta janela estiver aberta.',
      CODIGO: 'Sem câmera? Gerar código para digitar no celular',
      CODIGO_PASSOS:
        'No celular: Aparelhos conectados → Conectar um aparelho → Conectar com número de telefone, e digite:',
      CONECTADO: 'Aparelho conectado.',
      CARTAO_TITULO: 'WhatsApp não oficial',
      CARTAO_DESCRICAO:
        'Conecte um celular lendo o QR code, como no WhatsApp Web. Sem custo por mensagem e sem janela de 24 horas.',
      NOVA_TITULO: 'Caixa de WhatsApp não oficial',
      NOVA_EXPLICA:
        'A caixa fala pelo celular do número, conectado como aparelho (igual ao WhatsApp Web). Não tem modelos nem botões: menus saem como lista numerada.',
      PAREAR_DEPOIS: 'Parear depois',
      ABA_APARELHO: 'Aparelho',
      ABA_HIBRIDA: 'Caixa híbrida',
      HIBRIDA_EXPLICA:
        'Na caixa híbrida, o celular deste número fica conectado como aparelho (como o WhatsApp Web) e parte das respostas sai por ele, sem custo por mensagem. Disparos automáticos, modelos e botões continuam pela API oficial.',
      APARELHO_EXPLICA:
        'Esta caixa fala pelo celular do número, conectado como aparelho (como o WhatsApp Web). Se ele desconectar, a caixa para de enviar e receber até conectar de novo.',
      HIBRIDA_DESLIGADA: 'Caixa híbrida desabilitada',
      HIBRIDA_LIGADA: 'Caixa híbrida',
      HABILITAR_HIBRIDA: 'Habilitar caixa híbrida',
      DESABILITAR_HIBRIDA: 'Desabilitar caixa híbrida',
      VER_USO: 'Ver uso e histórico do aparelho em Nexus IA → Uso do WhatsApp',
      ROTEAMENTO: 'Por onde saem as respostas',
      ROTEAMENTO_EXPLICA:
        'Resposta pelo aparelho não é cobrada pela Meta. Disparos automáticos, botões, listas e modelos saem sempre pela API oficial, e também tudo o que o aparelho não conseguir enviar.',
      ROTEIA: 'Enviar respostas pelo aparelho',
      IA_PERCENTUAL: 'IA: % de atendimentos pela API oficial',
      IA_DICA:
        'Sorteado por conversa. Uma parte na oficial diminui o risco de bloqueio do número.',
      ATENDENTES: 'Atendentes respondem pelo',
      ROTAS: { aparelho: 'Aparelho', oficial: 'API oficial' },
      SALVAR: 'Salvar',
      SALVO: 'Roteamento salvo.',
      FECHAR: 'Fechar',
      ERRO: 'Não consegui carregar as caixas de WhatsApp.',
      ERRO_ACAO: 'Não consegui concluir a ação.',
    },
    COPIAR: 'Copiar',
    COPIADO: 'Copiado',
    GATEWAY: {
      EXPLICA:
        'O endereço que o SGP chama para mandar avisos (fatura vencendo, pagamento recebido) pelo WhatsApp oficial. Cada integração do SGP tem o seu.',
      SEM_INTEGRACAO:
        'Nenhuma integração do SGP cadastrada para esta empresa. Peça ao administrador da instalação.',
      ENDERECO: 'Endereço',
      SEM_ENDERECO: 'Esta integração ainda não tem endereço.',
      REFERENCIA: 'Referência {ref}',
      USOS: '{n} disparo(s) recebidos',
      ULTIMO_USO: 'último em {quando}',
      NUNCA_USADO: 'nenhum disparo ainda',
      IPS: 'Aceita chamadas de: {ips}',
      QUALQUER_IP: 'Aceita chamadas de qualquer IP',
      GERAR: 'Gerar endereço',
      ROTACIONAR: 'Gerar novo endereço',
      REVOGAR: 'Revogar',
      CONFIRMA_ROTACIONAR:
        'O endereço atual deixa de funcionar agora, e o novo precisa ser colado no SGP. Continuar?',
      CONFIRMA_REVOGAR:
        'O SGP para de conseguir disparar por este endereço na hora. Revogar?',
      PARAM_TO: 'Parâmetro do número (set_to)',
      PARAM_MSG: 'Parâmetro da mensagem (set_msg)',
      PARAM_CONTRATO: 'Parâmetro do contrato (set_contrato)',
      IPS_CAMPO: 'IPs permitidos (separados por vírgula; vazio = qualquer)',
      CONFIRMAR: 'Gerar',
      CANCELAR: 'Cancelar',
      COPIE_AGORA:
        'Copie agora: este endereço não aparece de novo (guardamos só uma impressão dele). Qualquer endereço anterior desta integração já parou de funcionar.',
      CONFIG_SGP: 'Cadastro de gateway no SGP',
      SO_ENDERECO: 'Só o endereço',
      FECHAR: 'Já copiei',
      MODELOS: 'Modelos',
      MODELOS_EXPLICA:
        'Cada modelo é uma #chave que o SGP dispara, ligada a um template aprovado. Nasce em ensaio: o disparo é conferido e registrado, sem ir ao cliente.',
      SEM_MODELOS: 'Nenhum modelo ainda.',
      NOVO_MODELO: 'Novo modelo',
      EDITAR: 'Editar',
      APAGAR: 'Apagar',
      CONFIRMA_APAGAR:
        'Apagar o modelo #{chave}? Disparos com essa chave passam a ser recusados.',
      LIGAR: 'Ligar envio',
      DESLIGAR: 'Voltar ao ensaio',
      CONFIRMA_LIGAR:
        'A partir de agora os disparos #{chave} vão de verdade para os clientes. Ligar?',
      ENVIANDO: 'enviando',
      ENSAIO: 'ensaio',
      DESLIGADO: 'desligado',
      TEXTO_SGP: 'Texto para o SGP',
      CHAVE: 'Chave (o que o SGP manda depois do #)',
      TEMPLATE: 'Caixa e template',
      ESCOLHA_TEMPLATE: 'Escolha o template',
      NAO_SERVE: 'não serve: {motivo}',
      SEM_TEMPLATES:
        'Nenhum template aprovado nas caixas de WhatsApp oficial desta empresa. Sincronize os templates na caixa e volte aqui.',
      CORPO: 'Corpo aprovado',
      VARIAVEL: 'Variável {n}',
      BOTAO: 'Botão "{texto}" ({tipo})',
      VARIAVEL_DICA: 'variável do SGP, ex.: cliente1',
      ATIVO: 'Modelo ativo',
      SALVAR: 'Salvar modelo',
      ERRO: 'Não consegui carregar o gateway.',
      ERRO_ACAO: 'Não consegui concluir a ação.',
    },
    DISPAROS: {
      TODAS: 'Todas as integrações',
      MODELO: 'Modelo',
      DESFECHO: 'Desfecho',
      TODOS: 'Todos',
      PERIODO: 'Período',
      DIAS: 'Últimos {n} dias',
      DIA: 'Últimas 24h',
      SO_RECUSADAS: 'Só as recusadas pela Meta',
      RECUSADAS: 'recusadas pela Meta',
      NA_FILA: 'na fila agora',
      FREIO:
        'Freio puxado: as mensagens recebidas estão atrasadas, e a fila de disparos espera antes do próximo lote.',
      VAZIO: 'Nenhum disparo com esse filtro no período.',
      ANTERIOR: 'Anterior',
      PROXIMA: 'Próxima',
      PAGINA: 'Página {pagina} de {total}',
      ERRO: 'Não consegui carregar os disparos.',
      ESTADOS: {
        na_fila: 'na fila',
        enviando: 'enviando',
        ensaio: 'ensaio',
        enviado: 'enviado',
        falhou: 'falhou',
        ignorado: 'repetição',
        recusado: 'recusado',
      },
      ENTREGA: {
        enviada: 'enviada',
        entregue: 'entregue',
        lida: 'lida',
        recusada: 'recusada pela Meta',
      },
    },
    SEM_RECURSO: 'A área Nexus IA não está disponível para esta empresa.',
    MANUTENCAO: {
      EXPLICA:
        'Quem procurou vocês durante uma manutenção fica aqui (a IA inclui sozinha quem está num POP em manutenção). O aviso é liberado quando a manutenção termina no SGP e sai na mesma conversa que o cliente abriu.',
      ESPERANDO:
        '{n} contato(s) esperando a manutenção terminar no SGP. O aviso deles é liberado quando ela for encerrada.',
      EM_ANDAMENTO: 'manutenção em andamento',
      NAO_CONFERIDA: 'não deu para conferir no SGP',
      BLOQUEADOS:
        '{n} ficaram esperando: a manutenção deles ainda não terminou.',
      MENSAGEM: 'Mensagem do aviso',
      MENSAGEM_DICA:
        'Use {nome} para o primeiro nome do cliente. Quem estiver sem nome recebe o texto sem ele.',
      PREVIA: 'Prévia (cliente "Bruna Silva")',
      SALVAR: 'Salvar mensagem',
      SALVA: 'Mensagem salva.',
      ENVIAR_TODOS: 'Enviar para os {n} liberados',
      ENVIAR_SELECIONADOS: 'Enviar para os selecionados ({n})',
      REMOVER_SELECIONADOS: 'Remover da lista ({n})',
      CONFIRMA_ENVIO:
        'Enviar o aviso agora? Só confirme se a manutenção terminou de verdade.',
      CONFIRMA_REMOVER:
        'Remover {n} contato(s) da lista? Eles não recebem o aviso.',
      RESERVADOS: '{n} aviso(s) sendo enviados. A lista atualiza sozinha.',
      NENHUM_RESERVADO: 'Não havia ninguém para enviar.',
      REMOVIDOS: '{n} contato(s) removidos.',
      VAZIO: 'Ninguém nesta situação.',
      TODOS: 'Todos',
      CONVERSAS: '{n} conversas',
      JANELA_FECHA: 'janela fecha {quando}',
      JANELA_FECHADA: 'janela de 24h fechada',
      ULTIMO_CONTATO: 'último contato {quando}',
      ENVIADO_EM: 'enviado {quando}',
      ERRO: 'Não consegui carregar os avisos.',
      ERRO_ACAO: 'Não consegui concluir a ação.',
      LIMITE:
        'Cada envio leva no máximo {n}; o restante fica para o próximo clique.',
      ESTADOS: {
        aguardando: 'Aguardando',
        enviando: 'Enviando',
        enviado: 'Enviado',
        fora_da_janela: 'Fora da janela',
        falhou: 'Falhou',
        cancelado: 'Removido',
      },
      ENTREGA: {
        no_caminho: 'a caminho',
        entregue: 'entregue',
        lida: 'lida',
        recusada: 'recusada pela Meta',
      },
    },
  },
};

export default { pt_BR: PT, en: PT };
